import type { SearchResultItem, SearchResultItemMetadata } from '@/api/generated/model';

function metaString(
  metadata: SearchResultItemMetadata | undefined,
  key: string
): string | undefined {
  const value = metadata?.[key];
  return typeof value === 'string' ? value : undefined;
}

function metaNumber(
  metadata: SearchResultItemMetadata | undefined,
  key: string
): number | undefined {
  const value = metadata?.[key];
  return typeof value === 'number' ? value : undefined;
}

export function formatCurrencyAmount(amount: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
}

export function formatSearchResultMetadata(result: SearchResultItem): string | undefined {
  const metadata = result.metadata;

  switch (result.type) {
    case 'account': {
      const balance = metaNumber(metadata, 'balance');
      const currency = metaString(metadata, 'currency') ?? 'USD';
      return balance !== undefined
        ? `Balance: ${formatCurrencyAmount(balance, currency)}`
        : undefined;
    }
    case 'transaction': {
      const amount = metaNumber(metadata, 'amount');
      const currency = metaString(metadata, 'currency') ?? 'USD';
      if (amount === undefined) return undefined;
      const prefix = amount > 0 ? '+' : '';
      return `${prefix}${formatCurrencyAmount(amount, currency)}`;
    }
    case 'goal': {
      const progress = metaNumber(metadata, 'progress');
      return progress !== undefined ? `Progress: ${Math.round(progress * 100)}%` : undefined;
    }
    case 'document':
      return metaString(metadata, 'type') ?? metaString(metadata, 'year');
    case 'party':
      return metaString(metadata, 'email');
    default:
      return undefined;
  }
}
